'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.pages = void 0;
var adapter_1 = require("../adapter");
var Pages = /** @class */ (function () {
    function Pages() {
    }
    /**
     * Get or filter pages by passing the params object
     */
    Pages.prototype.get = function (params) {
        return adapter_1.adapter.pages.get(params);
    };
    return Pages;
}());
exports.pages = new Pages();
